import { useCallback, useState } from 'react';
import { LightweightCarouselPrevNextButtons } from './lightweight-carousel-prev-next-buttons';

interface LightweightCarouselControlsProps {
  onNext: () => void;
  onPrev: () => void;
  children?: React.ReactNode;
  isMobile: boolean;
  isTablet: boolean;
  controls?: boolean;
}

export const LightweightCarouselControls: React.FC<LightweightCarouselControlsProps> = ({
  onPrev,
  onNext,
  children,
  isMobile,
  isTablet,
  controls,
}) => {
  const [controlsVisible, setControlsVisible] = useState(false);

  const handleHideControls = useCallback(() => {
    setControlsVisible(false);
  }, []);

  const handleShowControls = useCallback(() => {
    setControlsVisible(true);
  }, []);

  if (isMobile || isTablet || !controls) return <>{children}</>;
  return (
    <div
      style={{ display: 'contents' }}
      // use onMouseOver as when page is changed onMouseEnter is not fired on scroll to top
      onMouseOver={handleShowControls}
      onMouseLeave={handleHideControls}>
      {children}
      <LightweightCarouselPrevNextButtons show={controlsVisible} onNext={onNext} onPrev={onPrev} />
    </div>
  );
};
